import PropTypes from 'prop-types';
import styled from 'helpers/styles';
import ComponentStyles from 'styles/mixins/Component.styles';
import MenuItem from '@mui/material/MenuItem';

const StyledMenuItem = styled(MenuItem)`
  padding: ${props => props.theme.spacing(6/8)} ${props => props.theme.spacing(2)};
  
  &.MenuItem-size-smaller {
    font-size: ${props => props.theme.fontSize(15)} !important;
  }
  &.MenuItem-size-smallest {
    font-size: ${props => props.theme.fontSize(14)} !important;
  }
  &.MenuItem-size-tiny {
    font-size: ${props => props.theme.fontSize(13)} !important;
  }
  
  ${ComponentStyles}
`;

StyledMenuItem.propTypes = {
  theme: PropTypes.object
};

export default StyledMenuItem;
